const buttonBaseStyle = {
    color: '#fff',
    border: 'none',
    borderRadius: '50px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
    cursor: 'pointer',
};

const CustomersHeader = ({ goToDashboard, goToVerification }) => (
    <div
        style={{
            position: 'sticky',
            top: '20px',
            display: 'flex',
            justifyContent: 'space-between',
            gap: '10px',
            flexWrap: 'wrap',
            width: '100%',
            zIndex: 2,
        }}
    >
        <button
            type="button"
            className="fw-semibold p-2 px-3"
            style={{ ...buttonBaseStyle, backgroundColor: '#0E94C3', marginLeft: '20px' }}
            onClick={goToVerification}
        >
            <i className="bi bi-arrow-left me-1"></i> Back
        </button>
        <button
            type="button"
            className="fw-semibold p-2 px-3"
            style={{ ...buttonBaseStyle, backgroundColor: '#041F60', marginRight: '20px' }}
            onClick={goToDashboard}
        >
            Dashboard <i className="bi bi-graph-up-arrow ms-1"></i>
        </button>
    </div>
);

export default CustomersHeader;
